import { StyleSheet, Dimensions } from 'react-native'

export const styles = StyleSheet.create({
  //modal styles
  contentModalWrapper: {
    backgroundColor: '#FFFFFF',
    alignItems: 'center',
    paddingTop: 42,
    paddingBottom: 44,
  },
  fileIcon: {
    marginBottom: 20,
  },
  modalTitle: {
    fontSize: 18,
    fontWeight: '600',
    color: '#003353',
    lineHeight: 28,
  },
  buttonsContainer: {
    flexDirection: 'row',
  },
  modalButton: {
    width: 150,
    height: 48,
    borderRadius: 4,
    justifyContent: 'center',
    alignItems: 'center',
    marginLeft: 15,
    marginTop: 31,
  },
  cancelText: {
    color: '#007FCF',
    fontSize: 16,
    lineHeight: 24,
    fontWeight: '500',
  },
  confirmText: {
    color: '#FFFFFF',
    fontSize: 16,
    lineHeight: 24,
    fontWeight: '500',
  },
  //main component styles
  container: {
    width: '100%',
  },
  notesHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 6,
  },
  title: {
    color: '#335C75',
    fontSize: 16,
    fontWeight: '500',
    lineHeight: 24,
  },
  addContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  addNoteText: {
    marginLeft: 8,
    fontSize: 16,
    color: '#00A0F3',
    lineHeight: 24,
  },
  emptyNotesText: {
    color: '#A7B1C3',
    fontSize: 16,
    lineHeight: 24,
  },
  textArea: {
    backgroundColor: '#fff',
    borderWidth: 1,
    borderColor: '#007FCF',
    borderRadius: 4,
    borderTopRightRadius: 4,
    borderTopLeftRadius: 4,
    color: '#3E4756',
    fontSize: 16,
    lineHeight: 24,
  },
  saveButton: {
    alignSelf: 'flex-end',
    marginTop: 6,
  },
})
